import React, {useEffect, useRef, useState} from 'react';

import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    info,
    infoMsg,
    MAX_NAME,
    REQUIRED,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {awardService} from "../../../jwt/_services/clasificator/awardService";
import Switch from "react-bootstrap-switch";
import AwardLangs from "./_langs";
import {langAwardsService} from "../../../jwt/_services/relations/langAwardService";
import {showLoader} from "../../../components/loader/loader";
import * as Yup from "yup";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";


export default function AwardForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [status, setStatus] = useState(editMode ? props.item?.status : false);
    const [langChilds, setLangChilds] = useState([]);
    const [resultArray, setResultArray] = useState([]);
    const [childChanges, setChildChanges] = useState(false);
    const [loading, setLoading] = useState(false);
    const refAwaradLangs = useRef(null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        icon: Yup.string().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            code: savedData?.code,
            showOrder: savedData?.showOrder,
            icon: savedData?.icon
        }
    });

    const handleSwitchChange = () => {
        setStatus(!status);
    }

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            id: data.id,
            showOrder: data.showOrder,
            code: data.code,
            icon: data.icon,
            status: status,
        };
        if (!editMode) {
            //Save
            return awardService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    if (childChanges) {
                        saveChilds(resultData.id);
                    }else {
                        setLoading(false);
                    }
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return awardService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    if (childChanges) {
                        saveChilds(resultData.id);
                    }else {
                        setLoading(false);
                    }
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
        refAwaradLangs.current.changeDisabledInput(true);
    }

    const resetForm = () => {
        setLangChilds([]);
        setResultArray([]);
        setSavedData(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        setChildChanges(false);
        refAwaradLangs.current.resetForm();
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        setChildChanges(false);
        refAwaradLangs.current.changeDisabledInput(false);
    }

    const saveChilds = (id) => {
        let dataRequest = [];
        if (resultArray.length === 0) { // Empty Array
            langChilds.map((langAward) => {
                const data = {
                    id: langAward.id,
                    lang: langAward.lang,
                    awards: {id: id},
                    name: langAward.name,
                };
                dataRequest.push(data);
            });
        }else {
            resultArray.map((langAward) => {
                //Buscar el nombre que se acaba de modificar
                const langIndex = langChilds.findIndex(n => n.lang.id === langAward.lang.id);
                let langChildsA = langChilds.slice();
                const data = {
                    id: langAward.id,
                    lang: langAward.lang,
                    awards: {id: id},
                    name: langChildsA[langIndex].name,
                };
                dataRequest.push(data);
            });
        }
        if (!editMode) {
            langAwardsService.saveAll(dataRequest).then(resultData => {
                setResultArray(resultData);
                setLoading(false);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        } else {
            langAwardsService.updateAll(dataRequest).then(() => {
                setResultArray(dataRequest);
                setLoading(false);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        }
        setLoading(false);
    }

    const updateLangChilds = (langChildsP) => {
        if (langChildsP !== undefined) {
            setChildChanges(true);
            setLangChilds(langChildsP);
        }
    }

    const setForm = () => {
        props.setForm();
    }


    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="uid">UID Firebase</Label>
                                <Input type="id" name="uid" id="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Icono</Label>
                                <Input type="text" name="icon"
                                       placeholder="Icono"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.icon ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="icon" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Orden de presentación</Label>
                                <br/>
                                <Input type="number" name="showOrder"
                                       placeholder="Orden"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={handleSwitchChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="mdi mdi-book mr-2"/>
                        Información internacional
                    </CardTitle>
                    <CardBody>
                        <AwardLangs
                            ref={refAwaradLangs}
                            award={{id: savedData?.id}}
                            setForm={setForm}
                            updateItem={updateLangChilds}
                            key={"AwardLangId"}
                            editMode={editMode}
                            disableInputs={disableInputs}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>

            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}